module.exports = __webpack_public_path__ + "img/pokaz_wszystkie_wypadki.0eabb17b.svg";